import "@/App.css";
import { AudioProvider } from "@/context/AudioContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Pillars } from "@/components/Pillars";
import { WelcomeSessions } from "@/components/WelcomeSessions";
import { Sessions } from "@/components/Sessions";
import { About } from "@/components/About";
import { Features } from "@/components/Features";
import { BrainSection } from "@/components/BrainSection";
import { Pricing } from "@/components/Pricing";
import { MusicSection } from "@/components/MusicSection";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { AudioBar } from "@/components/AudioBar";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AudioProvider>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <Pillars />
          <WelcomeSessions />
          <Sessions />
          <About />
          <Features />
          <BrainSection />
          <Pricing />
          <MusicSection />
          <Contact />
        </main>
        <Footer />
        <AudioBar />
        <Toaster position="top-center" richColors />
      </div>
    </AudioProvider>
  );
}

export default App;
